import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import StudioPagination from '@/studioComponents/StudioPagination.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoLibraryTablePagination',
  props: {
    pageSize: {},
    totalCount: {},
    currentPage: {}
  },
  emits: ["fetch"],
  setup(__props: any, { emit }) {

const props = __props;





const onNext = () => {
  emit('fetch', {
    firstLoad: false,
    currentPage: props.currentPage + 1
  });
};

const onPrevious = () => {
  emit('fetch', {
    firstLoad: false,
    currentPage: props.currentPage - 1
  });
};

const onGoToFirstPage = () => {
  emit('fetch', {
    firstLoad: false,
    currentPage: 1
  });
};

const onGoToLastPage = () => {
  emit('fetch', {
    firstLoad: false,
    currentPage: Math.ceil(props.totalCount / props.pageSize)
  });
};

return (_ctx: any,_cache: any) => {
  return (_ctx.totalCount > _ctx.pageSize)
    ? (_openBlock(), _createBlock(StudioPagination, {
        key: 0,
        itemsPerPageCount: _ctx.pageSize,
        itemsCount: _ctx.totalCount,
        currentPage: _ctx.currentPage,
        suffix: "Videos",
        onNext: onNext,
        onPrevious: onPrevious,
        onGoToFirstPage: onGoToFirstPage,
        onGoToLastPage: onGoToLastPage
      }, null, 8, ["itemsPerPageCount", "itemsCount", "currentPage"]))
    : _createCommentVNode("", true)
}
}

})